export default __webpack_public_path__ + "static/media/6_long.9b193a73.svg";